<template>
  <div class="srmcloud-content">
    <banner clazz="srmcloud-banner" url="srmcloud" hasDivider>
      <template slot="buttons">
        <el-button class="banner-button" round @click="goMore('srm-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="srmcloud-section1">
      <div class="section1-content">
        <img class="section1-img" src="../../assets/img/srmCloud/section1@2x.png" alt="什么是甄云SaaS云平台"/>
        <span class="section1-misc">
          <h1 class="misc-title">一体化数字采购管理平台-甄采云</h1>
          <div class="misc-divider"></div>
          <p class="misc-content">
            一款自主可控和基于云部署的企业级采购管理平台，一站式满足企业采购申请、供应商管理、询报价、合同、对账等采购全流程管理。无需额外购买硬件、数周时间即可上线，超过1000个功能灵活配置，90%以上客制化需求无须二次开发，充分以用户为中心兼顾行业差异，让企业实现采购数字化不再难。
          </p>
          <el-button class="consult-button" @click.native="goMore('srm-yunpingtai-yanshi')">预约演示
            <img src="../../assets/img/bidding/icon_demo.svg" alt="预约演示">
          </el-button>
        </span>
      </div>
    </div>
    <div class="srmcloud-section2">
      <div class="section2-content">
        <h1 class="section2-title">解决的采购痛点</h1>
        <div class="section2-divider dib"></div>
        <div class="section2-main">
          <div class="content-box first dib">
            <img class="box-icon" src="../../assets/img/srmCloud/icon-1@2x.png" alt="效率低"/>
            <h1 class="box-title">效率低</h1>
            <p class="box-content">
              企业与企业之间协同效率低<br/>
              企业内部不同部门协同效率低
            </p>
          </div>
          <div class="content-box second dib">
            <img class="box-icon" src="../../assets/img/srmCloud/icon-2@2x.png" alt="成本高"/>
            <h1 class="box-title">成本高</h1>
            <p class="box-content">
              管理成本高<br/>
              采购成本高
            </p>
          </div>
          <div class="content-box third dib">
            <img class="box-icon" src="../../assets/img/srmCloud/icon-3@2x.png" alt="管控难"/>
            <h1 class="box-title">管控难</h1>
            <p class="box-content">
              合规性差<br/>
              采购不透明
            </p>
          </div>
          <div class="content-box fourth dib">
            <img class="box-icon" src="../../assets/img/srmCloud/icon-4@2x.png" alt="信息闭塞"/>
            <h1 class="box-title">信息闭塞</h1>
            <p class="box-content">
              数据难以共享和分析
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="srmcloud-section3 tc">
      <h1 class="section3-title">甄采云功能概括</h1>
      <div>
        <div class="section3-divider dib"></div>
      </div>
      <div class="section3-table">
        <div class="table-content dib tl">
          <div class="line first dib tc">
            <div class="cell custom-388 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/zhushuju-bg.png') + ')'}">
              <div class="container" @click="goMore('srm-gongneng-zhushuju')">
                <img class="cell-icon" src="../../assets/img/srmCloud/zhushuju_icon.png" alt="主数据管理"/>
                <h1 class="cell-title">主数据管理</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>物料特性</p>
                      <p>供应商档案</p>
                    </div>
                    <div class="fr">
                      <p>物料档案</p>
                      <p>货源与配额</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-469 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/xunyuan-bg.png') + ')'}">
              <a href="/purchasemanage" target="_blank">
                <div class="container">
                  <img class="cell-icon" src="../../assets/img/srmCloud/xunyuan_icon.png" alt="寻源管理"/>
                  <h1 class="cell-title">寻源管理</h1>
                  <div class="cell-divider dib"></div>
                  <div class="cell-content tl">
                    <div class="cell-detail">
                      <div class="fl">
                        <p>询报价管理</p>
                        <p>招投标管理</p>
                      </div>
                      <div class="fr">
                        <p>竞价拍卖</p>
                        <p>采购目录</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-273 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/shengchan.png') + ')'}">
              <div class="container" @click="goPurchasecoordination(3400)">
                <img class="cell-icon" src="../../assets/img/srmCloud/shengchan_icon.png" alt="生产协同"/>
                <h1 class="cell-title">生产协同</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>OME管理</p>
                      <p>第三方收货</p>
                    </div>
                    <div class="fr">
                      <p>工厂直发</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
          </div>
          <div class="line second dib tc">
            <div class="cell custom-281 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/gongyingshang.png') + ')'}">
              <a href="/supplier" target="_blank">
                <div class="container">
                  <img class="cell-icon" src="../../assets/img/srmCloud/gongyingshang_icon.png" alt="供应商管理"/>
                  <h1 class="cell-title">供应商管理</h1>
                  <div class="cell-divider dib"></div>
                  <div class="cell-content tl">
                    <div class="cell-detail">
                      <div class="fl">
                        <p>准入评估</p>
                        <p>绩效管理</p>
                      </div>
                      <div class="fr">
                        <p>分类/状态</p>
                        <p>整改&淘汰</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-469 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/hetong.png') + ')'}">
              <a href="/contractmanage" target="_blank">
                <div class="container">
                  <img class="cell-icon" src="../../assets/img/srmCloud/hetong_icon.png" alt="合同管理"/>
                  <h1 class="cell-title">合同管理</h1>
                  <div class="cell-divider dib"></div>
                  <div class="cell-content tl">
                    <div class="cell-detail">
                      <div class="fl">
                        <p>合同类型</p>
                        <p>合同模板</p>
                      </div>
                      <div class="fr">
                        <p>合同文本</p>
                        <p>合同履行</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-380 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/zhiliang-bg.png') + ')'}">
              <div class="container" @click="goPurchasecoordination(2956)">
                <img class="cell-icon" src="../../assets/img/srmCloud/zhiliang_icon.png" alt="质量协同"/>
                <h1 class="cell-title">质量协同</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>质量数据</p>
                      <p>质量事件</p>
                    </div>
                    <div class="fr">
                      <p>质量费用</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
          </div>
          <div class="line third dib tc">
            <div class="cell custom-469 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/xuqiu.png') + ')'}">
              <div class="container" @click="goMore('srm-gongneng-caigouxuqiu')">
                <img class="cell-icon" src="../../assets/img/srmCloud/xuqiu_icon.png" alt="采购需求管理"/>
                <h1 class="cell-title">采购需求管理</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>需求提报</p>
                      <p>汇总及审核</p>
                    </div>
                    <div class="fr">
                      <p>发布&确认</p>
                      <p>供应商产能</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-388 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/dingdan.png') + ')'}">
              <div class="container" @click="goPurchasecoordination(1376)">
                <img class="cell-icon" src="../../assets/img/srmCloud/dingdan_icon.png" alt="采购订单协同"/>
                <h1 class="cell-title">采购订单协同</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>订单生成&审核</p>
                      <p>订单过程监控</p>
                      <p>送货预约审核</p>
                    </div>
                    <div class="fr">
                      <p>发布&确认</p>
                      <p>送货安排</p>
                      <p>收发退货</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
            <div class="cell custom-273 dib"
                 :style="{'backgroundImage': 'url(' + require('../../assets/img/srmCloud/duizhang.png') + ')'}">
              <div class="container" @click="goPurchasecoordination(2470)">
                <img class="cell-icon" src="../../assets/img/srmCloud/duizhang_icon.png" alt="对账结算"/>
                <h1 class="cell-title">对账结算</h1>
                <div class="cell-divider dib"></div>
                <div class="cell-content tl">
                  <div class="cell-detail">
                    <div class="fl">
                      <p>扣费附加费</p>
                      <p>对账与审核</p>
                    </div>
                    <div class="fr">
                      <p>发票与付款</p>
                    </div>
                  </div>
                </div>
              </div>
              <p class="go-detail">了解详情 ></p>
            </div>
          </div>
        </div>
      </div>
      <h1 class="section3-title">甄采云.超越采购，推动战略执行</h1>
      <div>
        <div class="section3-divider dib"></div>
      </div>
      <div class="section3-collpase dib" @mouseleave="chooseTab('first')">
        <div class="section3-main">
          <div class="section3-choose">
            <div class="left-list">
              <div class="choice first" @mouseenter="chooseTab('first')"
                   :class="this.choice === 'first' ? 'is-choosed' : ''">
                <div class="choice-content">
                  <img class="icon" src="../../assets/img/srmCloud/3-1_ICON.png" alt="深度的采购闭环管理">
                  <h1 class="text">深度的采购闭环管理<br/>合规性提升45%</h1>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="choice second" @mouseenter="chooseTab('second')"
                   :class="this.choice === 'second' ? 'is-choosed' : ''">
                <div class="choice-content">
                  <img class="icon" src="../../assets/img/srmCloud/3-2_ICON.png" alt="丰富的采购资源">
                  <h1 class="text">丰富的采购资源<br/>寻源效率整体提升40% </h1>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="choice third" @mouseenter="chooseTab('third')"
                   :class="this.choice === 'third' ? 'is-choosed' : ''">
                <div class="choice-content">
                  <img class="icon" src="../../assets/img/srmCloud/3-3_ICON.png" alt="高效作业">
                  <h1 class="text">高效作业<br/>释放采购劳动力</h1>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="choice fourth" @mouseenter="chooseTab('fourth')"
                   :class="this.choice === 'fourth' ? 'is-choosed' : ''">
                <div class="choice-content">
                  <img class="icon" src="../../assets/img//srmCloud/3-4_icon.png" alt="通用技术平台">
                  <h1 class="text">通用技术平台<br/>安全稳定 </h1>
                </div>
                <div class="triangle"></div>
              </div>
              <div class="choice fifth" @mouseenter="chooseTab('fifth')"
                   :class="this.choice === 'fifth' ? 'is-choosed' : ''">
                <div class="choice-content">
                  <img class="icon" src="../../assets/img/srmCloud/3-5_ICON.png" alt="采购智能分析与预测">
                  <h1 class="text">采购智能分析与预测<br/>助力采购成本优化</h1>
                </div>
                <div class="triangle"></div>
              </div>
            </div>
            <div class="right-content">
              <div class="first-content content-img" v-show="choice === 'first'">
                <h1 class="title">深度的采购闭环管理 合规性提升45%</h1>
                <div class="text">
                  <p>供应商准入评审：分品类，多策略的准入管控机制</p>
                  <p>历史价格管理：询比价历史查询，采购价格库管控</p>
                  <p>供应商绩效管理绩效自动计算，绩效结果跟踪</p>
                </div>
                <img class="image" src="../../assets/img/srmCloud/1-peitu-1.png" alt="深度的采购闭环管理"/>
                <!--                <img class="image" src="../../assets/img/srmCloud/2-peitu-1.png" alt="深度的采购闭环管理"/>-->
              </div>
              <div class="second-content content-img" v-show="choice === 'second'">
                <h1 class="title">丰富的采购资源 寻源效率整体提升40%</h1>
                <div class="text">
                  <p>电商资源：平台已对接通用物资电商、MRO物资电商供应商系统无缝集成 </p>
                  <p>云平台撮合：需求发布云平台，触及云平台数万供应商，提升寻源效率 </p>
                </div>
                <img class="image single" src="../../assets/img/srmCloud/2-peitu-1.png" alt="丰富的采购资源"/>
              </div>
              <div class="third-content content-img" v-show="choice === 'third'">
                <h1 class="title">高效作业 释放采购劳动力</h1>
                <div class="text">
                  <p>业务超期预警：预制业务预警条件，及时提醒异常情况</p>
                  <p>自动对账：预制自动对账规则，减少人工核对</p>
                  <p>发票自动入账：支持与各主流ERP系统集成，接口对接生成应付数据</p>
                </div>
                <img class="image" src="../../assets/img/srmCloud/3-peitu-1.png" alt="高效作业释放采购劳动力"/>
                <!--                <img class="image" src="../../assets/img/srmCloud/3-peitu-2.png" alt="高效作业释放采购劳动力"/>-->
              </div>
              <div class="fourth-content content-img" v-show="choice === 'fourth'">
                <h1 class="title">通用技术平台 安全稳定</h1>
                <div class="text">
                  <p>通用数据接口：对主流ERP系统有成熟接口套件，随装随用，数百家客户验证，高效稳定</p>
                  <p>安全机制：专业级平台、数据、系统安全防护</p>
                </div>
                <img class="image" src="../../assets/img/srmCloud/4-1.png" alt="通用技术平台安全稳定"/>
                <!--                <img class="image" src="../../assets/img/srmCloud/4-2.png" alt="通用技术平台安全稳定"/>-->
              </div>
              <div class="fifth-content content-img" v-show="choice === 'fifth'">
                <h1 class="title">采购智能分析与预测 助力采购成本优化</h1>
                <div class="text">
                  <p>报价模型：可针对不同品类进行报价模型设定，建立多维价格信息库</p>
                  <p>大宗商品价格预警：基于大宗商品价格变动， 及时获取价格变动信息并进行价格调整</p>
                  <p>报表定制：为企业量身打造数据模型，助力企业采购决策，费用支出分析，价格分析等</p>
                </div>
                <img class="image" src="../../assets/img/srmCloud/5-1.png" alt="采购智能分析与预测,助力采购成本优化"/>
                <!--                <img class="image" src="../../assets/img/srmCloud/5-2.png" alt="采购智能分析与预测,助力采购成本优化"/>-->
              </div>
            </div>
          </div>
        </div>
        <el-button class="consult-btn" @click.native="goMore('srm-zhanlue-yanshi')">预约演示
          <img src="../../assets/img/bidding/icon_demo.svg" alt="">
        </el-button>
      </div>
      <h1 class="section3-title">典型客户案例</h1>
      <div class="section3-divider dib"></div>
      <div>
        <div class="section3-systemlist tl dib">
          <span class="expand-content dib">
            <div class="expandItem tc dib" :class="index === 0 ? 'expand' : ''" @mouseenter="listExpandOn(index)"
                 @mouseleave="listExpandOff"
                 @touchstart="listExpandOn(index)" @touchend="listExpandOn(index)"
                 :style="{'backgroundImage': item.yiz_img ? 'url(' + $global.globalPath + item.yiz_img + ')' : ''}"
                 v-for="(item, index) in expandItemList">
             <div class="expandItemMask">
                <img class="expandItemIcon" v-lazy="$global.globalPath + item.yiz_logo" alt="logo"/>
                <div class="expandItemTextContainer">
                  <p class="expandItemText textContent tl">{{index === 0 ? item.yiz_describe : item.title}}</p>
                  <p class="expandItemText textFooter tl">{{item.yiz_seo ? '——' + item.yiz_seo : ''}}</p>
                   <p class="expandShowDetail tc" @click="goClientDetail(item.id, item.status)">了解案例详情 >
                  </p>
                </div>
             </div>
          </div>
          </span>
          <div class="expandItem static tc dib" @click="listMove">
            <img class="expandItemIcon" src="../../assets/img/purchaseManage/arrow@2x.png" alt="expandItemIcon"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import * as className from '../../assets/js/dom'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'srmCloud',
  metaInfo () {
    return {
      title: this.$seo.srmcloud.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.srmcloud.keywords
      },
      {
        name: 'description',
        content: this.$seo.srmcloud.description
      }]
    }
  },
  data () {
    return {
      choice: 'first',
      platformValueListLen: 3,
      platformValueList: [
        {
          title: '供应商管理价值',
          content: ['100％的供应商管控覆盖1', '2倍以上的供应商开发效率提升', '6％以上的供应商成本节约']
        },
        {
          title: '寻源管理价值',
          content: ['100％的寻源采购过程透明度', '4倍以上的采购寻源效率提升', '12％以上的平均采购成本节约']
        },
        {
          title: '合同管理价值',
          content: ['100％的采购合同管理价值', '12％以上的平均采购成本节约', '4％以上的合同履约成本节约']
        }
      ],
      expandItemList: [
        {
          id: '1',
          status: '0',
          title: '加载中',
          yiz_describe: '当您看到这则信息，请检查网络链接',
          yiz_img: '',
          yiz_logo: '',
          yiz_seo: ''
        },
        {
          id: '2',
          status: '0',
          title: '加载中',
          yiz_describe: '当您看到这则信息，请检查网络链接',
          yiz_img: '',
          yiz_logo: '',
          yiz_seo: ''
        },
        {
          id: '3',
          status: '0',
          title: '加载中',
          yiz_describe: '当您看到这则信息，请检查网络链接',
          yiz_img: '',
          yiz_logo: '',
          yiz_seo: ''
        },
        {
          id: '4',
          status: '0',
          title: '加载中',
          yiz_describe: '当您看到这则信息，请检查网络链接',
          yiz_img: '',
          yiz_logo: '',
          yiz_seo: ''
        }
      ],
      moveList: true
    }
  },
  components: {
    hoverButton,
    banner
  },
  methods: {
    goPurchasecoordination (top) {
      let routeObj = this.$router.resolve({
        path: '/purchasecoordination',
        query: {
          top: top
        }
      })
      window.open(routeObj.href, '_blank')
    },
    goMore (code) {
      this.openRegister(false, code)
    },
    chooseTab (str) {
      this.choice = str
    },
    listMove (event) {
      if (this.expandItemList.length <= 4) {
        return false
      }
      let content = document.getElementsByClassName('expandItem')
      let dom = document.getElementsByClassName('static')[0]
      let evt = window.event || event
      if (this.$func.getCurrentBrowser() === 'IE9') {
        evt.cancelBubble = true // 阻止IE冒泡
      } else {
        evt.stopPropagation() // 阻止通用浏览器冒泡
      }
      let list = document.getElementsByClassName('expand-content')
      if (this.moveList) {
        className.addClass(dom, 'is-actived')
        className.addClass(list[0], 'is-moved')
        // 减去的5中包括 展示用的4个item和导航键头的1个static
        list[0].style.right = 175 * (content.length - 5) + 'px'
        let res = (content.length - 1) % 4 ? (content.length - 1) % 4 : 4
        if (this.currentExpand() < res) {
          this.listExpand(res)
        }
      } else {
        className.removeClass(dom, 'is-actived')
        className.removeClass(list[0], 'is-moved')
        list[0].style.right = ''
        if (this.currentExpand() > 3) {
          this.listExpand(0)
        }
      }
      this.moveList = !this.moveList
    },
    currentExpand () {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        if (className.hasClass(dom[i], 'expand')) {
          return i
        }
      }
      return 0
    },
    listExpandOn (index) {
      this.expandController = setTimeout(() => {
        this.listExpand(index)
      }, 100)
    },
    listExpandOff () {
      clearTimeout(this.expandController)
    },
    listExpand (index) {
      let dom = document.getElementsByClassName('expandItem')
      for (let i = 0; i < dom.length - 1; i++) {
        let contentDom = dom[i].getElementsByClassName('textContent')[0]
        //          let imgDom = dom[i].getElementsByClassName('expandItemIcon')[0]
        if (i !== index) {
          className.removeClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].title
          //            imgDom.src = this.$global.globalPath + this.expandItemList[i].logo
        } else {
          className.addClass(dom[i], 'expand')
          contentDom.innerText = this.expandItemList[i].yiz_describe
        }
      }
      //        let imgDom = dom[index].getElementsByClassName('expandItemIcon')[0]
      //        imgDom.src = this.$global.globalPath + this.expandItemList[index].img
    },
    goClientDetail (id, status) {
      // let routeUrl = this.$router.resolve({
      //   name: 'ClienteleDetile',
      //   query: {
      //     id: id
      //   }
      // })
      // if (status === '0') {
      //   window.open(routeUrl.href, '_self')
      // } else if (status === '1') {
      //   window.open(routeUrl.href, '_blank')
      // }
      if (status === '0') {
        let routeObj = this.$router.resolve({
          name: 'ClienteleDetile',
          query: {
            id: id
          }
        })
        window.open(routeObj.href, '_blank')
      } else if (status === '1') {
        this.$api.post('/cases/twenty_four_hour', '', (r) => {
          if (r.code === 0) {
            if (r.data === 1) {
              let routeObj = this.$router.resolve({
                name: 'ClienteleDetile',
                query: {
                  id: id
                }
              })
              window.open(routeObj.href, '_blank')
            } else {
              this.openRegister(false, 'srm-anli-xiangqing')
            }
          } else {
            this.$message.error(r.message)
          }
        })
      } else {

      }
    },
    getExpandData () {
      this.$api.post('/cases/get_cases', { webname: 'srmcloud', cases_sum: '' }, (r) => {
        if (r.code === 0) {
          this.expandItemList = r.data
          if (this.expandItemList.length > 8) {
            this.expandItemList = this.expandItemList.slice(0, 8)
          }
        } else {
          this.$message.error(r.msg)
        }
      })
    }
  },
  mounted () {
  },
  created () {
    this.getExpandData()
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/srmcloud.scss";
</style>



// WEBPACK FOOTER //
// srmcloud.vue?fd30a53c